module.exports = __webpack_public_path__ + "img/__icon_CYSTERNA_SPOŻYWCZA.3a604539.svg";